// Button that opens (or closes) the Map for the selected day
import { MapIcon } from '@heroicons/react/20/solid';
import clsx from 'clsx';

import { useSchedulerContext } from '@/context/SchedulerContext';

/**
 * Map button. The Map opens in place of the Jobs list, below the day tabs and
 * filters so the dispatcher stays oriented; it is closed with this button or
 * the X on the map. It shows live trucks today, GPS routes on past days, and
 * planned jobs on future days.
 * @returns {React.JSX.Element}
 */
export default function SchedulerViewSwitch() {
  const { schedulerView, setSchedulerView } = useSchedulerContext();
  const isMapOpen = schedulerView === 'map';
  return (
    <div className="scheduler-view-switch flex items-center">
      <button
        type="button"
        className={clsx(
          'btn btn-sm gap-1',
          isMapOpen ? 'btn-accent' : 'btn-outline btn-accent'
        )}
        aria-pressed={isMapOpen}
        title={isMapOpen ? 'Close the map' : 'Open the map'}
        onClick={() => setSchedulerView(isMapOpen ? 'list' : 'map')}
      >
        <MapIcon className="size-4" />
        {'Map'}
      </button>
    </div>
  );
}
